const ToggleOpen = {
  start() {
    $('[data-toggle-open]').click(this.toggle);
  },
  toggle(e) {
    e.preventDefault();
    const $target = $(e.currentTarget.dataset.toggleOpen);
    $target.toggleClass('is-open');
  }
};

export default ToggleOpen;
